import { ROUTES } from '../utils/constants.js';

const dashboard = ({ key, label, role, path, legacyPaths = [] }) => Object.freeze({
  key,
  label,
  role,
  path,
  legacyPaths: Object.freeze(legacyPaths),
});

// Dashboard destinations and their owning roles are an application contract.
// Firestore may control how navigation is presented, but cannot redefine where
// a role lands or broaden access to another role's dashboard.
export const DASHBOARD_ROUTE_CONTRACT = Object.freeze([
  dashboard({
    key: 'teacher-dashboard',
    label: 'Teacher Dashboard',
    role: 'teacher',
    path: ROUTES.TEACHER_DASHBOARD,
  }),
  dashboard({
    key: 'admin-dashboard',
    label: 'Admin Dashboard',
    role: 'admin',
    path: ROUTES.ADMIN_DASHBOARD,
  }),
  dashboard({
    key: 'dev-dashboard',
    label: 'Dev Dashboard',
    role: 'dev',
    path: ROUTES.DEV_DASHBOARD,
    legacyPaths: ['/dev-dashboard'],
  }),
  dashboard({
    key: 'parent-dashboard',
    label: 'Parent Dashboard',
    role: 'parent',
    path: ROUTES.PARENT_DASHBOARD,
  }),
]);

export const DASHBOARD_ROUTE_PERMISSIONS = Object.freeze(
  Object.fromEntries(
    DASHBOARD_ROUTE_CONTRACT.flatMap(({ path, legacyPaths, role }) => (
      [path, ...legacyPaths].map(route => [route, Object.freeze([role])])
    )),
  ),
);

const dashboardPathByRole = Object.freeze(
  Object.fromEntries(DASHBOARD_ROUTE_CONTRACT.map(({ role, path }) => [role, path])),
);

export function dashboardPathForRole(role) {
  return dashboardPathByRole[role] || ROUTES.TEACHER_DASHBOARD;
}
